import { isFeatureActive } from '../../selectors/configSelectors';
import { WHATSAPP_BANNER_2018 } from '../../flags/features';
import { getOrderStatusTrackingOrderType } from '../../selectors/trackingSelectors';
import { TRACK_ORDER_STATUS_PAGE } from './types';

export function trackViewedOrderStatusPage(initialLoad = false) {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.order.status) {
      return false;
    }
    const orderStatus = state.order.status;
    const orderId = orderStatus.order && orderStatus.order.id ? orderStatus.order.id : null;
    const statusMessage =
      orderStatus.attributes && orderStatus.attributes.analytics
        ? orderStatus.attributes.analytics.status_message
        : null;
    const infoBannerId = orderStatus && orderStatus.infoBanner ? orderStatus.infoBanner.id : null;

    const payload = {
      name: 'Viewed order status page',
      properties: {
        'Order Status id': statusMessage,
        'Order ID': orderId,
        'Info Banner ID': infoBannerId,
        'Event Type': initialLoad ? 'manual' : 'status change',
        ...getOrderStatusTrackingOrderType(state),
      },
    };

    return dispatch({
      type: TRACK_ORDER_STATUS_PAGE,
      payload,
    });
  };
}

export function trackViewedWhatsappBanner() {
  return (dispatch, getState) => {
    const state = getState();

    const orderStatus = state.order && state.order.status;
    const whatsappBannerFeatureOn = isFeatureActive(state, WHATSAPP_BANNER_2018);
    const infoBanner = orderStatus && orderStatus.infoBanner;
    const hasOptedIn = infoBanner && infoBanner.whatsappOptedIn;
    const isShowingWhatappBanner =
      whatsappBannerFeatureOn && infoBanner && infoBanner.modalType === 'whatsapp' && !hasOptedIn;

    if (!orderStatus || !isShowingWhatappBanner) {
      return false;
    }

    const orderId = orderStatus.order && orderStatus.order.id ? orderStatus.order.id : null;
    const statusMessage =
      orderStatus.attributes && orderStatus.attributes.analytics
        ? orderStatus.attributes.analytics.status_message
        : null;

    const payload = {
      name: 'Viewed whatsapp banner',
      properties: {
        'Order Status': statusMessage,
        'Order ID': orderId,
      },
    };

    return dispatch({
      type: TRACK_ORDER_STATUS_PAGE,
      payload,
    });
  };
}

export function trackOptedInForWhatsapp() {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.order.status) {
      return false;
    }
    const orderStatus = state.order.status;
    const orderId = orderStatus.order && orderStatus.order.id ? orderStatus.order.id : null;
    const statusMessage =
      orderStatus.attributes && orderStatus.attributes.analytics
        ? orderStatus.attributes.analytics.status_message
        : null;

    const payload = {
      name: 'Opted in whatsapp notifications',
      properties: {
        'Order Status': statusMessage,
        'Order ID': orderId,
      },
    };

    return dispatch({
      type: TRACK_ORDER_STATUS_PAGE,
      payload,
    });
  };
}

export function trackClickedInfoBanner() {
  return (dispatch, getState) => {
    const state = getState();
    const orderStatus = state.order.status;
    const infoBannerId = orderStatus && orderStatus.infoBanner ? orderStatus.infoBanner.id : null;

    if (!orderStatus || !infoBannerId) {
      return false;
    }

    const orderId = orderStatus.order && orderStatus.order.id ? orderStatus.order.id : null;
    const statusMessage =
      orderStatus.attributes && orderStatus.attributes.analytics
        ? orderStatus.attributes.analytics.status_message
        : null;

    const payload = {
      name: 'Clicked order status info banner',
      properties: {
        'Order Status': statusMessage,
        'Order ID': orderId,
        'Info Banner ID': infoBannerId,
      },
    };

    return dispatch({
      type: TRACK_ORDER_STATUS_PAGE,
      payload,
    });
  };
}

export function trackSawMissedCallModal() {
  return (dispatch, getState) => {
    const state = getState();
    const orderStatus = state.order.status;
    const missedCallModal = orderStatus && orderStatus.missedCallModal;

    if (!missedCallModal) {
      return false;
    }

    const orderId = orderStatus.order && orderStatus.order.id ? orderStatus.order.id : null;
    const analyticsAttributes = orderStatus.attributes && orderStatus.attributes.analytics;
    const riderStatus = analyticsAttributes ? analyticsAttributes.rider_status : null;
    const parentCallId = missedCallModal.parentCallSid || null;

    const payload = {
      name: 'Viewed missed call message',
      properties: {
        rider_status: riderStatus,
        'Order ID': orderId,
        type: 'modal',
        parent_call_sid: parentCallId,
        mvt_ce_111: 'variant',
      },
    };

    return dispatch({
      type: TRACK_ORDER_STATUS_PAGE,
      payload,
    });
  };
}

/**
 * Tracking for interacting with missed call from rider modal
 * @param {string} eventName, “Dismissed missed call message” or “Tapped call rider”
 */
export function trackMissedCallModalAction(eventName) {
  return (dispatch, getState) => {
    const state = getState();
    const orderStatus = state.order.status;
    const missedCallModal = orderStatus && orderStatus.missedCallModal;

    if (!missedCallModal) {
      return false;
    }

    const orderId = orderStatus.order && orderStatus.order.id ? orderStatus.order.id : null;
    const analyticsAttributes = orderStatus.attributes && orderStatus.attributes.analytics;
    const riderStatus = analyticsAttributes ? analyticsAttributes.rider_status : null;
    const parentCallId = missedCallModal.parentCallSid || null;

    const payload = {
      name: eventName,
      properties: {
        rider_status: riderStatus,
        'Order ID': orderId,
        parent_call_sid: parentCallId,
      },
    };

    return dispatch({
      type: TRACK_ORDER_STATUS_PAGE,
      payload,
    });
  };
}
